import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { TopicSpecialist } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';


export function getColumns(util: UtilityService, domain: DomainDataService, service: VolunteeringAreaService, app: AppService) {

	const columns: GridColumn<TopicSpecialist, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 120 }),
		buildColumn(util, 'Id', row => row.topicId, { header: 'TopicId', hidden: true }),
		buildColumn(util, 'Id', row => row.volunteerPerson?.id, { header: 'Approved VolunteerPersonId' }),
		buildColumn(util, 'FullName', row => row.volunteerPerson?.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.volunteerStatusId ? domain.data().volunteerStatusesMap[row.volunteerStatusId]?.name : '', { header: 'Volunteer Status', filter: { operator: FilterOperator.Contains, value: 'Approved' } }),
		buildColumn(util, 'Text', row => `${domain.data().topicsMap[row.topicId]?.order.toString().padStart(2, '0')} - ${row.topicName}`, { header: 'Topic', group: 'asc' }),
		buildColumn(util, 'TrueFalse', row => row.isTopicEnabled, { header: 'Is Topic Enabled', hidden: true }),
		buildColumn(util, 'Text', row => row.agreementsSigned, { header: 'Agreements', width: 80, hidden: true }),
		buildColumn(util, 'YesNo', row => row.attendedOrientation, { header: 'Attended Orientation', width: 80, hidden: true }),
		buildColumn(util, 'YesNo', row => !!row.interviewDateUTC, { header: 'Interviewed', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEnVideo ? 'Added' : 'Missing', { header: 'English Video', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEsVideo ? 'Added' : 'Missing', { header: 'Spanish Video', width: 80, hidden: true }),
		buildColumn(util, 'Number', row => row.signUpsCount.currentTrimester, { header: `${service.selectedTrimesterName()} Sign-ups`, headerTooltip: `Total Sign-ups for ${service.selectedTrimesterName()}`, width: 80 }),
	];

	if (service.volunteeringData()?.selectedNextTrimester?.trimesterId) {
		columns.push(
			buildColumn(util, 'Number', row => row.signUpsCount.nextTrimester, { header: `${service.selectedNextTrimesterName()} Sign-ups`, headerTooltip: `Total Sign-ups for ${service.selectedNextTrimesterName()}` }),
		)
	}

	return columns;

}
